import React, { useEffect, useState } from 'react';
import { TableRow, TableCell } from 'carbon-components-react';
import { SubtractAlt16 } from '@carbon/icons-react';
import { currentUser } from 'redux/session/selectors';
import { selectAlertsData } from 'redux/alerts';
import { useDispatch, useSelector } from 'react-redux';
import { deleteUserStart, resetUserAdded } from 'redux/organisation/action';

import { addAlert, removeAlert } from 'redux/alerts/actions';

const DeleteIcon = ({ selected }: { selected: boolean }) => {
  return (
    <div className="display-row-delete-icon">
      {selected && <SubtractAlt16 />}
    </div>
  );
};
const DisplayUsers: React.FC<any> = ({ row, getRowProps }: any) => {
  const alertList = useSelector(selectAlertsData);
  const [selected, setSelected] = useState<boolean>(false);
  const [currentRowId, setCurrentRowId] = useState<string>('');
  const [deleteActive, setDeleteActive] = useState<boolean>(false);
  const handleOnMouseEnter = () => setSelected(true);
  const handleOnMouseLeave = () => setSelected(false);
  const dispatch: any = useDispatch();
  const {
    Organisation: { name, id: orgId },
    email: currentUserEmail
  } = useSelector(currentUser);

  const startDeletion = () => {
    dispatch(
      deleteUserStart({
        id: row.id,
        orgId
      })
    );
    dispatch(removeAlert(row.id));
  };
  const existingAlert = alertList.length > 0;
  const notificationProps = {
    title: 'Remove?',
    subtitle: `User will lose access to ${name}`,
    lowContrast: true,
    doActions: startDeletion
  };
  const handleOnDeleteClick = () => {
    setCurrentRowId(row.id);

    dispatch(resetUserAdded());
    dispatch(
      addAlert('DELETE_USER_GROUP', 'error', '', '', {
        id: row.id, // only one inline notification is supported
        withClose: false,
        type: 'inline',
        notificationProps
      })
    );
  };

  useEffect(() => {
    const foundAlert = alertList.find((item: any) => item.id === currentRowId);
    foundAlert ? setDeleteActive(true) : setDeleteActive(false);
  }, [alertList, currentRowId]);

  return (
    <TableRow
      {...getRowProps({ row })}
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}
      isSelected={deleteActive}
    >
      {row.cells.map((cell: any) => (
        <TableCell key={cell.id}>
          {cell.info.header === 'name' &&
          row.cells[1].value === currentUserEmail
            ? `${cell.value} (You)`
            : cell.value}
        </TableCell>
      ))}

      <TableCell
        className="bx--table-column-menu"
        onClick={() => {
          row.cells[1].value !== currentUserEmail && handleOnDeleteClick();
        }}
      >
        {row.cells[1].value !== currentUserEmail && (
          <DeleteIcon selected={selected && !existingAlert} />
        )}
      </TableCell>
    </TableRow>
  );
};
DisplayUsers.displayName = 'DisplayUsers';
export default DisplayUsers;
